import type { ComputedRef, Ref } from 'vue'

import { useSidebarPrivileges } from '@entities/viewer'

import { useTeamsStore } from './store'
import { useTeamsApi } from '../../api/teams/list.hook'

interface FiltersTeamsReturn {
  refSearch: Ref<string>
  canManage: ComputedRef<boolean>
  isLoading: ComputedRef<boolean>
  submitSearch: () => Promise<void>
  openCreateModal: () => void
}

/** The search box holds a draft; nothing is requested until "Search" or Enter. */
export const useFiltersTeams = (): FiltersTeamsReturn => {
  const router = useRouter()
  const route = useRoute()
  const store = useTeamsStore()
  const { canManageTeams } = useSidebarPrivileges()

  const refSearch = ref<string>('')

  const canManage = computed<boolean>(() => canManageTeams.value)
  const isLoading = computed<boolean>(() => store.isLoading)

  const syncDraft = (): void => {
    refSearch.value = store.getFilterSearch ?? ''
  }

  const submitSearch = async (): Promise<void> => {
    store.setFilterSearch(refSearch.value.trim() || null)

    await router.push({
      query: {
        ...route.query,
        q: store.getFilterSearch || undefined,
        page: undefined,
      },
    })
    await useTeamsApi()
  }

  const openCreateModal = (): void => {
    store.setModalCreate(true)
  }

  // The store, not the URL: the list hydrates it from the query, and the draft follows once it has.
  watch(() => store.getFilterSearch, syncDraft, { immediate: true })

  return { refSearch, canManage, isLoading, submitSearch, openCreateModal }
}
